import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'language', method: 'GET', body: null, token: token })
}
